<template>
  <b-container fluid class="split-layout w-100 h-100 p-0">
    <div class="split__left justify-content-center align-items-center">
      <slot name="left"></slot>

      <template v-if="!hasSlot('left')">
        <custom-carousel
          class="split-layout__carousel"
          :slides="[
            {
              title: 'How It Works',
              desc:
                'Lorem ipsum dolor sit amet consectetur adipisicing elit sed do',
              image: require('@/assets/images/board-lg.svg')
            },
            {
              title: 'Find a Tool',
              desc: `Search for the tool you're looking for using the search bar`,
              image: require('@/assets/images/search-lg.svg')
            },
            {
              title: 'Select Dates',
              desc: `Select the amount of days you'd like to rent your tool`,
              image: require('@/assets/images/calendar-lg.svg')
            },
            {
              title: 'Checkout',
              desc: 'Review your information and go for an easy checkout',
              image: require('@/assets/images/checkout-lg.svg')
            }
          ]"
        ></custom-carousel>
      </template>
    </div>
    <div class="split__right justify-content-center align-items-center">
      <slot name="right"></slot>
    </div>
  </b-container>
</template>
<script>
/**
 * ==================================================================================
 * Split page template
 * ==================================================================================
 **/

import CustomCarousel from '@/components/lists/CustomCarousel'

export default {
  components: {
    CustomCarousel
  },
  methods: {
    hasSlot(name = 'default') {
      return !!this.$slots[name] || !!this.$scopedSlots[name]
    }
  }
}
</script>
<style scoped lang="scss">
.split-layout /deep/ {
  background-color: var(--bg-color);
  display: flex;
  flex-direction: row;

  .split-layout__carousel {
    background-color: var(--bg-color);
    margin: auto;

    .carousel-control-prev {
      left: 50px;
    }

    .carousel-control-next {
      right: 50px;
    }
  }

  .split__left,
  .split__right {
    display: flex;
    overflow-y: auto;
  }

  .split__left {
    width: 53.4%;
  }

  .split__right {
    flex-grow: 1;
    background: #fff;
  }
}

@media (max-height: 450px) {
  .split-layout /deep/ {
    .split__left {
      .split-layout__carousel {
        padding: 50px 0;

        .carousel-control-prev > span,
        .carousel-control-next > span {
          bottom: 56px;
        }
      }
    }
  }
}

@media (max-width: 950px) {
  .split-layout /deep/ {
    .split__left {
      width: 43.4%;
    }
  }
}

@media (max-width: 760px) {
  .split-layout /deep/ {
    .split__left {
      display: none;
    }
  }
}
</style>
